import { NestedHome } from '@habity/types';
import { ProfileFeatureItem } from '~/components/ui/wraps/components/ProfileFeatureItem';
import { ICONS } from '~/constants';
import {
  getCategoryText,
  getLivingSpace,
  getPlotSize,
  getRooms,
  getLocationDisplayText,
} from '@habity/services';
import { ProfileSkeleton } from '~/components/ui/Skeletons';
import { ProfileFeatures } from '~/components/ui/wraps/page';

interface FeatureItemsProps {
  home: NestedHome;
  variant?: 'comma-separated' | 'bullet-separated';
}

export function FeatureItems({ home, variant }: FeatureItemsProps) {
  const { address } = home || {};
  const {
    city,
    area,
    municipality,
    rooms,
    living_space,
    additional_space,
    plot_size,
    category,
  } = address || {};

  const profileFeatureItems: ProfileFeatureItem[] = [
    {
      icon: ICONS.CITY,
      label: getLocationDisplayText({ city, municipality, area }),
      show: !!city,
    },
    {
      icon: ICONS.CATEGORY,
      label: getCategoryText(category),
      show: true,
    },
    {
      icon: ICONS.ROOMS,
      label: getRooms(rooms),
      show: !!rooms,
    },
    {
      icon: ICONS.LIVING_SPACE,
      label: getLivingSpace(living_space, additional_space),
      show: !!living_space,
    },
    {
      icon: ICONS.PLOT_SIZE,
      label: getPlotSize(plot_size),
      show: !!plot_size,
    },
  ];

  return (
    <ProfileSkeleton borderRadius="md">
      <ProfileFeatures
        items={profileFeatureItems.filter((i) => i.show)}
        variant={variant}
      />
    </ProfileSkeleton>
  );
}
